import React from 'react'

export default function ShopSection() {
  return (
    <div>ShopSection</div>
  )
}
